import StatusIndicator from "./StatusIndicator";

export default function ServiceItem({
  name,
  status,
}: {
  name: string;
  status: "online" | "offline";
}) {
  return (
    <div className="flex items-center justify-between px-4 py-4 sm:px-6 sm:py-5">
      <div className="flex flex-col gap-0.5">
        <span className="text-md font-bold -tracking-wide text-neutral-950">
          {name}
        </span>
        <span className="text-sm font-medium -tracking-wide text-neutral-500">
          {status === "online" ? "No issues" : "Service under maintenance"}
        </span>
      </div>
      <StatusIndicator status={status} />
    </div>
  );
}
